<template>
    <section>
        <header class="justify-between align-items-end mb-3">
            <b-form-group
                :label="$t('Element')"
                label-for="wall_element"
                class="flex-grow-1 mb-0"
            >
                <wall-element-select
                    id="wall_element"
                    v-model="element"
                    :wall-id="wallId"
                    :project-id="projectId"
                    required
                />
            </b-form-group>

            <b-button
                :disabled="!element"
                :title="$t('Add element to wall')"
                class="ml-3"
                @click="newElement"
            >
                <fa icon="plus" :title="$t('Add element to wall')" />
            </b-button>
        </header>

        <spinner v-if="pending" />

        <no-results-found v-if="!pending && !items.length" />

        <wall-elements-item
            v-for="(element, index) in items"
            :key="`wall_${wallId}_element_${element.id}_item`"
            v-model="items[index].info"
            :element="element"
            :api-url="apiUrl + '/' + element.id"
            :element-type="element.type"
            :title="element.toString"
            class="mb-3"
            @deleted="removeElement(index)"
        />
</section>
</template>

<script>
    import WallElementsItem from '@/components/walls/WallElementsItem';
    import WallElementSelect from '@/components/selects/WallElementSelect';
    import fetchData from "@/mixins/fetchData";
    import Spinner from "@/components/Spinner";
    import NoResultsFound from "@/components/NoResultsFound";

    export default {
        name: 'WallElements',
        components: {NoResultsFound, Spinner, WallElementSelect, WallElementsItem},
        mixins: [fetchData],
        props: {
            projectId: {
                type: [Number, String],
                required: true,
            },
            wallId: {
                type: [Number, String],
                required: true,
            },
        },
        data() {
            return {
                element: null,
            };
        },
        computed: {
            apiUrl() {
                return `/api/walls/${this.wallId}/elements`;
            }
        },
        methods: {
            async newElement() {
                if (!this.element) {
                    return;
                }

                let {data} = await this.axios.put(this.apiUrl + '/' + this.element.id);

                this.$root.$emit('saved::element-service');
                this.items.unshift(data);
                this.element = null;
            },

            removeElement(index) {
                this.items.splice(index, 1);
            },
        },
    };
</script>
